import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelper from '../../../general/js/basket/currency-helper';

export default class BasketTotal extends React.Component {
    render() {
        return (
            <div className="basket-total">
                <div className="basket-total__row">
                    <span className="basket-total__row-title">Total:</span>
                    <span>{CurrencyHelper.convertToPounds(this.props.basket.total)}</span>
                </div>
                {'totalMc' in this.props.basket ? <div className="basket-total__row">
                    <span className="basket-total__row-title">
                        Total with: <span className="basket-total__mc-icon"/> </span>
                    <span>{CurrencyHelper.convertToPounds(this.props.basket.totalMc)}</span>
                </div> : null}
            </div>
        );
    }
}

BasketTotal.propTypes = {
    basket: PropTypes.object.isRequired,
};
